<template>
  <div class="contain">
    <!--头部-->
    <head-comp ref="header"></head-comp>
    <!--页面渲染部分-->
    <router-view @control="control"></router-view>
    <!--底部-->
    <div class="foot">
      <div class="ft_top">
        <p>地址：池州市贵池区建设西路389号 </p>
        <p>邮编：247000 电话：0566-2091931 传真：0566-2091931</p>
         <p>版权所有：池州职业技术学院 <a :href="Link_Url.homeurl" target="_blank">皖ICP备11021113号-1</a>
        | 技术支持：南京冠邦网络技术有限责任公司</p></div>
    </div>
  </div>
</template>

<script>
import headComp from "../components/headComp";
import { Link_Url } from "../api/config";

export default {
  components: { headComp },
  data() {
    return {
      Link_Url: Link_Url
    };
  },
  methods: {
    control() {
      this.$refs.header.signed();
      this.$router.push({ path: "/home/encrollabout" });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/home.vue